export default __webpack_public_path__ + "static/media/toggle-on.60b1c9ec.svg";